import React, { useEffect, useState, useRef } from 'react';

const Transform = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  const [currentCell, setCurrentCell] = useState(null);
  const [prevCell, setPrevCell] = useState(null);
  const gridCols = 18;
  const gridRows = 6;

  useEffect(() => {
    const section = document.getElementById('transform-section');
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (section) observer.observe(section);

    return () => {
      if (section) observer.unobserve(section);
    };
  }, []);

  const handleMouseMove = (e) => {
    const rect = sectionRef.current?.getBoundingClientRect();
    if (!rect) return;

    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const col = Math.min(gridCols - 1, Math.max(0, Math.floor((x / rect.width) * gridCols)));
    const row = Math.min(gridRows - 1, Math.max(0, Math.floor((y / rect.height) * gridRows)));
    const nextCell = { col, row };

    if (!currentCell || currentCell.col !== col || currentCell.row !== row) {
      setPrevCell(currentCell);
      setCurrentCell(nextCell);
    }
  };

  const handleMouseLeave = () => {
    setCurrentCell(null);
    setPrevCell(null);
  };

  return (
    <div
      id="transform-section"
      ref={sectionRef}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      className="relative h-auto lg:py-40 lg:px-12 flex text-slate-950 dark:text-gray-100 bg-opacity-30"
      style={{
        backgroundImage: `url(https://www.nerolac.com/sites/default/files/2023-07/victorian-pop-ceiling-wall-design.webp)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Background Overlay */}
      <div className="font-Poppins inset-0 bg-white bg-opacity-10 dark:bg-slate-950 dark:bg-opacity-50"></div>

      {/* <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage:
            'linear-gradient(rgba(255,255,255,0.08) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.08) 1px, transparent 1px)',
          backgroundSize: '68px 68px',
          opacity: 0.7,
        }}
      /> */}

      {Array.from({ length: gridRows }).map((_, rowIndex) =>
        Array.from({ length: gridCols }).map((_, colIndex) => {
          const isCurrent = currentCell?.row === rowIndex && currentCell?.col === colIndex;
          const isPrev = prevCell?.row === rowIndex && prevCell?.col === colIndex;
          return (
            <div
              key={`${rowIndex}-${colIndex}`}
              className="pointer-events-none absolute transition-colors duration-300"
              style={{
                top: `${(rowIndex / gridRows) * 100}%`,
                left: `${(colIndex / gridCols) * 100}%`,
                width: `${100 / gridCols}%`,
                height: `${100 / gridRows}%`,
                backgroundColor: isCurrent
                  ? 'rgba(249, 115, 22, 0.5)'
                  : isPrev
                  ? 'rgba(38, 78, 162, 0.5)'
                  : 'transparent',
                border: '1px solid rgba(255,255,255,0.02)',
              }}
            />
          );
        })
      )}

      {/* Content Section */}
      <div
        className={`relative bg-gray-200 bg-opacity-50 dark:bg-slate-900 dark:bg-opacity-80 lg:w-[30%] px-6 py-10 sm:py-14 sm:px-10 m-2 shadow-lg max-w-lg sm:max-w-3xl transform transition-transform duration-1000 ${
          isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'
        }`}
      >
        <h1 className="text-4xl md:text-5xl font-bold mb-4 dark:text-white">Transform Your Home</h1>
        <div className="h-2 w-32 bg-orange-500 mb-3 mt-4 rounded-full"></div>
        <p className="text-lg sm:text-xl dark:text-gray-200">
          Elevate every space with Qoncave's exceptional designs.
        </p>
      </div>
    </div>
  );
};

export default Transform;
